import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "counter-badge-spinner q-ml-sm"
}
const _hoisted_2 = { class: "q-px-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_badge = _resolveComponent("q-badge")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createVNode(_component_q_spinner, {
          color: "primary",
          size: "1em"
        })
      ]))
    : (_openBlock(), _createBlock(_component_q_badge, _normalizeProps(_mergeProps({ key: 1 }, _ctx.bindProps)), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "prepend"),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.displayCount), 1),
          _renderSlot(_ctx.$slots, "append")
        ]),
        _: 3
      }, 16))
}